/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentRunsCreateAgentRun } from "../../funcs/agentRunsCreateAgentRun.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateAgentRunRequest$inboundSchema,
};

export const tool$agentRunsCreateAgentRun: ToolDefinition<typeof args> = {
  name: "agent-runs-create-agent-run",
  description: `Start a saved agent run

Starts an asynchronous background run for a saved agent and returns the queued run record. Use the run retrieval endpoint to poll status or the events endpoint to stream progress.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentRunsCreateAgentRun(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
